
import { useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../styles/services.css';
import { AuthContext } from '../context/AuthContext';
import { getServices } from '../api/service'; // ✅ use your API helper

export default function Services() {
  const { user } = useContext(AuthContext);
  const [servicesFromDB, setServicesFromDB] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Load service data from backend
  useEffect(() => {
    getServices()
      .then((res) => setServicesFromDB(res.data))
      .catch((err) => console.error('Error fetching services:', err));
  }, []);

  // ✅ Static UI metadata
  const servicesData = {
    causal: {
      title: "Consciousness Work",
      description: `Consciousness work is based on Advaita (non-duality), 
      focusing on soul reintegration, heart awakening, and truth beyond separation. 
      It heals by bringing presence to fragmented parts of the soul, allowing love itself to transform. 
      This is the core healing layer, where self-realization begins and the ego dissolves into pure awareness. 
      It includes Inner Child Integration, Trauma Release, Relationship Repair, Career & Purpose Alignment, Limited 
      Belief Reprogramming, Overthinking & Stress Detox, Fear & Anxiety Transmutation, Self-Mastery Activation, Parental 
      Wound Healing, Wealth Consciousness Clearing`,
      services: [
        { name: "Consciousness Work", image: "/images/causal.png" },
      ],
    },
    astral: {
      title: "Astral Healing",
      description: `Astral healing works in the realm of energy, polarity, and creation. 
      Once the causal layer is healed, this healing helps you cleanse the aura, remove energetic cords, 
      and attract positive vibrations into your life.It operates on duality (positive/negative) to restore harmony, 
      raise frequency, and help you manifest your soul-aligned life.`,
      services: [
        { name: "Akashic Records Healing", image: "/images/akashic.png" },
        { name: "Past Life Regression", image: "/images/pastlife.png" },
        { name: "Feminine Energy Empowerment", image: "/images/divine_feminine.png" },
        { name: "Masculine Energy Activation", image: "/images/divine_masculine.png" },
        { name: "Sacred Energy Healing", image: "/images/sacred.png" },
        { name: "Aura Cleansing", image: "/images/aura.png" },
        { name: "Ancestral Lineage Healing", image: "/images/ancestral.png" },
        { name: "Spiritual Healing of Disease", image: "/images/spiritual.png" },
        { name: "Manifestation of Desired Life", image: "/images/manifestation.png" },
      ],
    },
  };

  // ✅ Merge DB (price + _id) into static data
  const enrichServices = (uiServices) =>
    uiServices.map((ui) => {
      const match = servicesFromDB.find((db) => db.name === ui.name);
      return {
        ...ui,
        price: match?.price || 0,
        id: match?._id || '',
      };
    });

  const enrichedData = {
    causal: {
      ...servicesData.causal,
      services: enrichServices(servicesData.causal.services),
    },
    astral: {
      ...servicesData.astral,
      services: enrichServices(servicesData.astral.services),
    },
  };

  const handleBook = (serviceId) => {
    if (!user) {
      Swal.fire({
        icon: 'warning',
        title: 'Login Required',
        text: 'Please login first!',
        timer: 1000,
        showConfirmButton: false,
      });
      setTimeout(() => {
        navigate('/login', {
          state: { from: location.pathname + '/' + serviceId },
          replace: true,
        });
      }, 1000);
    } else {
      navigate(`/book/${serviceId}`);
    }
  };

  const ServiceCard = ({ service }) => (
    <div className="service-card">
      <h3>{service.name}</h3>
      <img src={service.image} alt={service.name} className="service-image" />
      <p className="price">₹ {service.price}</p>
      {user?.role !== "admin" && service.id && (
        <button onClick={() => handleBook(service.id)}>Book Now</button>
      )}
    </div>
  );

  return (
    <div className="services-wrapper">
      <section className="section-container">
        <h1>{enrichedData.causal.title}</h1>
        <div className="causal-layout">
          <div className="causal-left">
            {enrichedData.causal.services.map((s) => (
              <ServiceCard key={s.name} service={s} />
            ))}
          </div>
          <div className="causal-right">
            <p className="section-description">{enrichedData.causal.description}</p>
          </div>
        </div>
      </section>

      <section className="section-container">
        <h1>{enrichedData.astral.title}</h1>
        <p className="section-description">{enrichedData.astral.description}</p>
        <div className="services-grid">
          {enrichedData.astral.services.map((s) => (
            <ServiceCard key={s.name} service={s} />
          ))}
        </div>
      </section>
    </div>
  );
}
